import BuildIcon from "@mui/icons-material/Build";
import { ROOM_CONDITIONS, DormitoryServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListRoomConditions from "./List";
import CreateRoomCondition from "./Create";
import EditRoomCondition from "./Edit";

export const resources = {
  isMenu: true,
  icon: <BuildIcon />,
  name: DormitoryServicePath + ROOM_CONDITIONS,
  title: "Състояния на стаи",
  list: <ListRoomConditions />,
  create: <CreateRoomCondition />,
  createPermission: permissions.canManageDormitoryRoomConditions,
  edit: <EditRoomCondition />,
  editPermission: permissions.canManageDormitoryRoomConditions,
  permission: permissions.canPreviewDormitoryRoomConditions,
};
